/**
 * Every event the product emits to the dev overlay, and every command it
 * provides, in one place.
 *
 * Pure constants, so vite.config.ts can read the lists too: a prod bundle that
 * still contains one of these names fails the build (devOverlayBuildGate).
 */

export const DEV_EVENT_NAMES = [
  "ws.inbound",
  "ws.outbound",
  "ws.lifecycle",
] as const;

/**
 * Shortcuts for hot paths, each provided by the component that owns the UI
 * control — so one exists only while that control is on screen.
 */
export const DEV_COMMAND_NAMES = [
  "tutor.sendChat",
  "tutor.submitWork",
  "tutor.nextBite",
] as const;

/** Only in the real implementations; a prod bundle must never contain it. */
export const DEV_HOOK_MARKER = "devHook:";
